module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    staticClass: "form-control",
    attrs: {
      "onfocus": "this.select()"
    },
    domProps: {
      "value": _vm.formattedValue
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.update($event)
      },
      "blur": _vm.update
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-10d5f05a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CurrencyInput.vue
// module id = 426
// module chunks = 1